// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 9945 ? "weisstechniksim" : chunkId) + "." + {"3630":"4b058fd6","7873":"24565726","9945":"e418da65"}[chunkId] + ".chunk.css";
};